import { Injectable } from '@angular/core';
import { HttpProvider } from "../http/http";

/*
  Generated class for the PayRecordProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PayRecordProvider {

  constructor(public http: HttpProvider) {
  }

  getPayRecord(page,pagesize){
    return this.http.hPost('/account/get_balance_log',{page:page,pagesize:pagesize});
  }

}



// WEBPACK FOOTER //
// ./src/providers/pay-record/pay-record.ts